import { PageDialog } from "@/components/dialog/PageDialog"
import { QueryRender } from "@/components/helpers/QueryRender"
import { useAttendanceEvents } from "@/entities/attendanceEvent/useAttendanceEvent"
import { useAuth } from "@/hooks/useAuth"
import { AttendanceEventContent } from "@/pages/AttendanceEvent"

import { useState } from "react"

function sortByCreatedAt<T extends { created_at: Date }>(items: T[] | undefined): T[] {
   if (!items) return []
   return items.sort((a, b) => b.created_at.getTime() - a.created_at.getTime())
}

export default function AbsencesAJustifier() {
   const { user } = useAuth()
   const { data: attendanceEvents, ...query } = useAttendanceEvents({
      young_id: user?.id || "",
      optionWhereNotJustified: true,
   })
   const [selectedEventId, setSelectedEventId] = useState<string | null>(null)

   return (
      <>
         <div className="container mx-auto py-6">
            <div className="bg-white shadow rounded-lg p-6">
               <div className="mb-6">
                  <h1 className="text-2xl font-bold">Absences et retards à justifier</h1>
               </div>
               <QueryRender
                  query={query}
                  data={attendanceEvents}
                  emptyMessage="Aucune absence ou retard à justifier, félicitations !"
                  showEmptyMessage={attendanceEvents?.length === 0}
               >
                  {(attendanceEvents) => (
                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {sortByCreatedAt(attendanceEvents).map((event) => (
                           <div
                              key={event.id}
                              className="card bg-base-100 shadow-md hover:shadow-lg cursor-pointer transition-shadow"
                              onClick={() => setSelectedEventId(event.id)}
                           >
                              <div className="card-body">
                                 <AttendanceEventContent
                                    id={event.id}
                                    user={user!}
                                    variant="small"
                                 />
                              </div>
                           </div>
                        ))}
                     </div>
                  )}
               </QueryRender>
            </div>
         </div>
         <PageDialog isOpen={!!selectedEventId} onClose={() => setSelectedEventId(null)}>
            {selectedEventId && (
               <AttendanceEventContent id={selectedEventId} user={user!} variant="full" />
            )}
         </PageDialog>
      </>
   )
}
